import { Predicates } from "../../../../libraries/predicates/predicates";
import { formatCollectionOptions } from "../../helpers/collections.helper";
import { ArtworkApprovalActions } from "../../state/approvals";
import { ArtworkApprovalRequestTypes } from "../../state/approvals/data.type";
import OptionFormatter from "../../../../components/OptionFormatter";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import {
  formatDecorTechIntoOption,
  getDecorTechs,
} from "../../../../helpers/decor-tech.helper";
import { PrintingTechniqueActions } from "../../state/printingTechnique/create";
import { CreatePrintingTechniqueTypes } from "../../state/printingTechnique/create/data";
import {
  formatColorIntoOption,
  getColors,
} from "../../../../helpers/color.helper";
import { getMolds } from "../../../../helpers/mold.helper";
import { MoldsAsyncSelect } from "../moldsAsyncSelect";
import { useArtworkApprovalContextStore } from "../../context/approvals/ArtworkApprovalsContext";
import { DecorationTechniqueAsyncSelect } from "../decorationTechniqueAsyncSelect";
import { PrintingTechniqueColorAsyncSelect } from "../printingTechniqueColorAsyncSelect";
import { ArtworkCollectionAsyncSelect } from "../artworkCollectionAsyncSelect";
import { useCallback, useContext, useEffect, useMemo, useState, useRef } from "react";
import { URL } from "../../../../libraries/http/url";
import useAxios from "../../../../utils/useAxios";
import { usePageableTable } from "../../../../context/PageableTableContext";



export const PrintingTechniqueFilterForm = () => {
  const { state, dispatch } = useArtworkApprovalContextStore();

  const axios = useAxios();
  const abortControllerRef = useRef<AbortController | null>(null);
  const {
    dispatch: dispatchPageTable,
    state: { offset },
  } = usePageableTable();

  const handleUpdateFilters = (key: any, value: any) => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_SEARCH_FILTERS,
        {
          ...state.printingTechniqueSearchFilters,
          [key]: value,
        },
      ),
    );
  };
  const [hasFilterdApplied, setHasFilteredApplied] = useState(false);

  const getPrintingTechnique = useCallback(
    async ({
      search,
      id,
      limit,
    }: {
      search?: any;
      id?: string | number;
      limit?: string | number;
    }) => {

      dispatch(
        ArtworkApprovalActions.setStateValue(
          ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_SEARCH_IS_LOADING,
          true,
        ),
      )

      // Abort previous request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      const controller = new AbortController();
      abortControllerRef.current = controller;

      const searchParams = URL.createSearchParams({
        ...search,
        id,
        limit: limit || 50,
      });

      const url = !!id
        ? `/artwork/printing-technique/${id}`
        : `/artwork/printing-technique/?${searchParams.toString()}`;

      try {
        const response = await axios.get(url, { signal: controller.signal });

        if (response.status === 200) {
          // setData(response.data);
        }

        return response.data;
      } catch (e) {
        console.log(e);
      } finally {
      }
    },
    [axios],
  );

  const handleSearch = async (callback: any) => {
    const filters = {
      search: {
        search: state.printingTechniqueSearchFilters?.code,
        status: "APPROVED",
        name: state.printingTechniqueSearchFilters?.name,
        limit: 50,
        offset: offset,
        collection: state.printingTechniqueSearchFilters?.collection?.id,
        deco_tech_id:
          state.printingTechniqueSearchFilters?.decoration_technique?.id,
        color: state.printingTechniqueSearchFilters?.color?.name,
        molds: state.printingTechniqueSearchFilters?.molds?.map(
          (mold) => mold.id,
        ),
      },
    };

    const res = await getPrintingTechnique({ ...filters });

    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_SEARCH_RESULTS,
        res,
      ),
    )

    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_SEARCH_IS_LOADING,
        false,
      ),
    )
  };

  const handleClearFilters = () => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_PRINTING_TECHNIQUE_SEARCH_FILTERS,
        {
          collection: null,
          color: null,
          name: "",
          code: "",
          // purchased_parts: "",
          // technical_file_comment: "",
          decoration_technique: null,
          molds: [],
          printingTechnique: null,
          limit: 0,
          offset: 0,
          requesting_market: { full_name: "", id: "", short_name: "" },
          search: "",
        },
      ),
    );
  };

  useEffect(() =>{
    handleSearch(null)
  },[offset])


  return (
    <>
      <div className="w-100">
        <div className="row">
          <div className="col-lg-4 p-0">
            <div className="row p-0">
              <div className="col-lg-3">
                <label className="form-label" htmlFor="printing-technique-code">
                  Code
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="printing-technique-code"
                  id="printing-technique-code"
                  onInput={(e: any) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                    handleUpdateFilters("code", e.target.value);
                  }}
                  value={state?.printingTechniqueSearchFilters?.code ?? undefined}
                />
              </div>
              <div className="col-lg-9">
                <label className="form-label" htmlFor="printing-technique-name">
                  Name
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="printing-technique-name"
                  id="printing-technique-name"
                  onChange={(e: any) =>
                    handleUpdateFilters("name", e.target.value)
                  }
                  value={state?.printingTechniqueSearchFilters?.name ?? undefined}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-3 form-group">
            <ArtworkCollectionAsyncSelect
              onChanged={(e: any) => {
                handleUpdateFilters("collection", e);
              }}
              value={
                state?.printingTechniqueSearchFilters?.collection ?? undefined
              }
            />
          </div>
          <div className="col-lg-5">
            <DecorationTechniqueAsyncSelect
              onChanged={(e: any) => {
                handleUpdateFilters("decoration_technique", e);
              }}
              value={
                state?.printingTechniqueSearchFilters?.decoration_technique ??
                undefined
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <PrintingTechniqueColorAsyncSelect
              onChanged={(e: any) => handleUpdateFilters("color", e)}
              value={state.printingTechniqueSearchFilters?.color ?? undefined}
            />
          </div>

          <div className="col-md-6 form-group">
            <MoldsAsyncSelect
              value={state.printingTechniqueSearchFilters?.molds ?? []}
              onChanged={(e: any) => {
                handleUpdateFilters("molds", e);
              }}
            />
          </div>
        </div>

        <div className="row p-0">
          <div className="d-flex justify-content-end gap-3 px-1 mt-2">
            <button
              className="btn btn-outline-primary"
              onClick={handleClearFilters}
              disabled={hasFilterdApplied}
            >
              Clear
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSearch}
              // disabled={hasFilterdApplied}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {/*Requesting Market*/}
    </>
  );
};
